webpackJsonp([18116671869107,156544657062075,235176306749093,275075819617530,159537844214909,62581369279858],{

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 291);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	
	/***/ 1:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ }),
	
	/***/ 291:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Toggle = __webpack_require__(292);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;
	
	/***/ }),
	
	/***/ 292:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Toggle;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _general = __webpack_require__(293);
	
	var _general2 = _interopRequireDefault(_general);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Toggle(_ref) {
	  var checked = _ref.checked,
	      onChange = _ref.onChange,
	      name = _ref.name;
	
	  var inputProps = {
	    checked: checked,
	    className: _general2.default.input,
	    name: name,
	    type: 'checkbox',
	    onChange: onChange
	  };
	
	  var indicatorProps = {
	    className: (0, _classnames2.default)(_general2.default.indicator, {
	      'bg-green': checked,
	      'bg-black': !checked
	    }),
	    style: {
	      width: '60px',
	      height: '30px',
	      borderRadius: '30px'
	    }
	  };
	
	  var circleProps = {
	    className: (0, _classnames2.default)(_general2.default.circle, _defineProperty({}, _general2.default.activeCircle, checked)),
	    style: {
	      width: '16px',
	      height: '16px',
	      margin: '7px'
	    }
	  };
	
	  return _react2.default.createElement(
	    'label',
	    { className: _general2.default.control },
	    _react2.default.createElement('input', inputProps),
	    _react2.default.createElement(
	      'div',
	      indicatorProps,
	      _react2.default.createElement('div', circleProps)
	    )
	  );
	}
	
	Toggle.propTypes = {
	  checked: _propTypes2.default.bool.isRequired,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func
	};
	
	Toggle.defaultProps = {
	  checked: false
	};
	
	/***/ }),
	
	/***/ 293:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"control":"general__control___3HvTB cursor-pointer display-block position-relative userSelect-none","input":"general__input___3hfBb opacity-0 position-absolute zi-negative","indicator":"general__indicator___3UiRx position-relative display-block transitionDuration-m userSelect-none","circle":"general__circle___3TQ-E position-absolute pinTL bg-white borderRadius-circle transitionDuration-m","activeCircle":"general__activeCircle___1qIKb"};
	
	/***/ })
	
	/******/ });
	//# sourceMappingURL=marvel-ui-toggle.js.map

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(519);


/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	module.exports = function(obj) {
	    if (typeof obj === 'string') return camelCase(obj);
	    return walk(obj);
	};
	
	function walk (obj) {
	    if (!obj || typeof obj !== 'object') return obj;
	    if (isDate(obj) || isRegex(obj)) return obj;
	    if (isArray(obj)) return map(obj, walk);
	    return reduce(objectKeys(obj), function (acc, key) {
	        var camel = camelCase(key);
	        acc[camel] = walk(obj[key]);
	        return acc;
	    }, {});
	}
	
	function camelCase(str) {
	    return str.replace(/[_.-](\w|$)/g, function (_,x) {
	        return x.toUpperCase();
	    });
	}
	
	var isArray = Array.isArray || function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	};
	
	var isDate = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	var isRegex = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var has = Object.prototype.hasOwnProperty;
	var objectKeys = Object.keys || function (obj) {
	    var keys = [];
	    for (var key in obj) {
	        if (has.call(obj, key)) keys.push(key);
	    }
	    return keys;
	};
	
	function map (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        res.push(f(xs[i], i));
	    }
	    return res;
	}
	
	function reduce (xs, f, acc) {
	    if (xs.reduce) return xs.reduce(f, acc);
	    for (var i = 0; i < xs.length; i++) {
	        acc = f(acc, xs[i], i);
	    }
	    return acc;
	}


/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

	var currencySymbolMap = __webpack_require__(724)
	
	module.exports = function getSymbolFromCurrency (currencyCode) {
	  if (typeof currencyCode !== 'string') return undefined
	  var code = currencyCode.toUpperCase()
	  if (!currencySymbolMap.hasOwnProperty(code)) return undefined
	  return currencySymbolMap[code]
	}
	
	module.exports.currencySymbolMap = currencySymbolMap


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	module.exports = {
	  'AED': 'د.إ',
	  'AFN': '؋',
	  'ALL': 'L',
	  'AMD': '֏',
	  'ANG': 'ƒ',
	  'AOA': 'Kz',
	  'ARS': '$',
	  'AUD': '$',
	  'AWG': 'ƒ',
	  'AZN': '₼',
	  'BAM': 'KM',
	  'BBD': '$',
	  'BDT': '৳',
	  'BGN': 'лв',
	  'BHD': '.د.ب',
	  'BIF': 'FBu',
	  'BMD': '$',
	  'BND': '$',
	  'BOB': '$b',
	  'BRL': 'R$',
	  'BSD': '$',
	  'BTC': '฿',
	  'BTN': 'Nu.',
	  'BWP': 'P',
	  'BYR': 'Br',
	  'BYN': 'Br',
	  'BZD': 'BZ$',
	  'CAD': '$',
	  'CDF': 'FC',
	  'CHF': 'CHF',
	  'CLP': '$',
	  'CNY': '¥',
	  'COP': '$',
	  'CRC': '₡',
	  'CUC': '$',
	  'CUP': '₱',
	  'CVE': '$',
	  'CZK': 'Kč',
	  'DJF': 'Fdj',
	  'DKK': 'kr',
	  'DOP': 'RD$',
	  'DZD': 'دج',
	  'EEK': 'kr',
	  'EGP': '£',
	  'ERN': 'Nfk',
	  'ETB': 'Br',
	  'ETH': 'Ξ',
	  'EUR': '€',
	  'FJD': '$',
	  'FKP': '£',
	  'GBP': '£',
	  'GEL': '₾',
	  'GGP': '£',
	  'GHC': '₵',
	  'GHS': 'GH₵',
	  'GIP': '£',
	  'GMD': 'D',
	  'GNF': 'FG',
	  'GTQ': 'Q',
	  'GYD': '$',
	  'HKD': '$',
	  'HNL': 'L',
	  'HRK': 'kn',
	  'HTG': 'G',
	  'HUF': 'Ft',
	  'IDR': 'Rp',
	  'ILS': '₪',
	  'IMP': '£',
	  'INR': '₹',
	  'IQD': 'ع.د',
	  'IRR': '﷼',
	  'ISK': 'kr',
	  'JEP': '£',
	  'JMD': 'J$',
	  'JOD': 'JD',
	  'JPY': '¥',
	  'KES': 'KSh',
	  'KGS': 'лв',
	  'KHR': '៛',
	  'KMF': 'CF',
	  'KPW': '₩',
	  'KRW': '₩',
	  'KWD': 'KD',
	  'KYD': '$',
	  'KZT': 'лв',
	  'LAK': '₭',
	  'LBP': '£',
	  'LKR': '₨',
	  'LRD': '$',
	  'LSL': 'M',
	  'LTC': 'Ł',
	  'LTL': 'Lt',
	  'LVL': 'Ls',
	  'LYD': 'LD',
	  'MAD': 'MAD',
	  'MDL': 'lei',
	  'MGA': 'Ar',
	  'MKD': 'ден',
	  'MMK': 'K',
	  'MNT': '₮',
	  'MOP': 'MOP$',
	  'MRO': 'UM',
	  'MRU': 'UM',
	  'MUR': '₨',
	  'MVR': 'Rf',
	  'MWK': 'MK',
	  'MXN': '$',
	  'MYR': 'RM',
	  'MZN': 'MT',
	  'NAD': '$',
	  'NGN': '₦',
	  'NIO': 'C$',
	  'NOK': 'kr',
	  'NPR': '₨',
	  'NZD': '$',
	  'OMR': '﷼',
	  'PAB': 'B/.',
	  'PEN': 'S/.',
	  'PGK': 'K',
	  'PHP': '₱',
	  'PKR': '₨',
	  'PLN': 'zł',
	  'PYG': 'Gs',
	  'QAR': '﷼',
	  'RMB': '￥',
	  'RON': 'lei',
	  'RSD': 'Дин.',
	  'RUB': '₽',
	  'RWF': 'R₣',
	  'SAR': '﷼',
	  'SBD': '$',
	  'SCR': '₨',
	  'SDG': 'ج.س.',
	  'SEK': 'kr',
	  'SGD': '$',
	  'SHP': '£',
	  'SLL': 'Le',
	  'SOS': 'S',
	  'SRD': '$',
	  'SSP': '£',
	  'STD': 'Db',
	  'STN': 'Db',
	  'SVC': '$',
	  'SYP': '£',
	  'SZL': 'E',
	  'THB': '฿',
	  'TJS': 'SM',
	  'TMT': 'T',
	  'TND': 'د.ت',
	  'TOP': 'T$',
	  'TRL': '₤',
	  'TRY': '₺',
	  'TTD': 'TT$',
	  'TVD': '$',
	  'TWD': 'NT$',
	  'TZS': 'TSh',
	  'UAH': '₴',
	  'UGX': 'USh',
	  'USD': '$',
	  'UYU': '$U',
	  'UZS': 'лв',
	  'VEF': 'Bs',
	  'VND': '₫',
	  'VUV': 'VT',
	  'WST': 'WS$',
	  'XAF': 'FCFA',
	  'XBT': 'Ƀ',
	  'XCD': '$',
	  'XOF': 'CFA',
	  'XPF': '₣',
	  'YER': '﷼',
	  'ZAR': 'R',
	  'ZWD': 'Z$'
	}


/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(782),
	    createBaseEach = __webpack_require__(790);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(781),
	    isArrayLike = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(164),
	    baseGet = __webpack_require__(274),
	    baseIteratee = __webpack_require__(133),
	    baseMap = __webpack_require__(783),
	    baseSortBy = __webpack_require__(785),
	    baseUnary = __webpack_require__(165),
	    compareMultiple = __webpack_require__(788),
	    identity = __webpack_require__(100),
	    isArray = __webpack_require__(25);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),

/***/ 785:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(142);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(787);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(59);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(493),
	    baseOrderBy = __webpack_require__(784),
	    baseRest = __webpack_require__(276),
	    isIterateeCall = __webpack_require__(499);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FaqItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generalModule = __webpack_require__(734);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FaqItem(_ref) {
	  var question = _ref.question,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.item },
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.heading },
	      question
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.subtitle },
	      children
	    )
	  );
	}
	
	FaqItem.propTypes = {
	  question: _propTypes2.default.string,
	  children: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"src-components-modules-FaqItem-style----general-module---item---3PVDc position-relative lineHeight-copy overflow-hidden","heading":"src-components-modules-FaqItem-style----general-module---heading---2JbiB textAlign-left fontWeight-5 breakPointS-fontSize-s breakPointM-fontSize-s breakPointL-fontSize-m fontSize-m","subtitle":"src-components-modules-FaqItem-style----general-module---subtitle---3EwY- textAlign-left c-slate breakPointS-fontSize-s breakPointM-fontSize-s breakPointL-fontSize-m fontSize-m"};

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"swirl":"_39vnBHMWLsi7pPa0DeCN2- position-absolute fontSize-xxs textAlign-left transitionDuration-m textTransform-uppercase","badge":"_219-q9e5tuGLd0ofxt17RK borderStyle-solid borderWidth-1 display-inlineBlock fontSize-xs fontWeight-5 textAlign-center whiteSpace-nowrap textTransform-uppercase","badgeGreen":"_2zNUqrJ6DY72K1P6scdnYk bg-green borderColor-green c-white","badgeTransparent":"_3oOz-m7NNwWuSmoZTWybs9 bg-transparent borderColor-green c-green"};

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = BillingSwitch;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _grid = __webpack_require__(5);
	
	var _position = __webpack_require__(44);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _toggle = __webpack_require__(520);
	
	var _toggle2 = _interopRequireDefault(_toggle);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Swirl = __webpack_require__(601);
	
	var _Swirl2 = _interopRequireDefault(_Swirl);
	
	var _BillingSwitch = __webpack_require__(764);
	
	var _BillingSwitch2 = _interopRequireDefault(_BillingSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BillingSwitch(_ref) {
	  var _cx;
	
	  var onSwitch = _ref.onSwitch,
	      yearlyPriceShown = _ref.yearlyPriceShown,
	      discountValue = _ref.discountValue;
	
	  var badgeClasses = (0, _classnames2.default)(_BillingSwitch2.default.badge, (_cx = {}, _cx[_BillingSwitch2.default.badgeGreen] = yearlyPriceShown, _cx[_BillingSwitch2.default.badgeTransparent] = !yearlyPriceShown, _cx));
	  return _react2.default.createElement(
	    _position2.default,
	    { type: 'relative' },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _grid.InlineGrid,
	        { size: 'xs' },
	        _react2.default.createElement(
	          _heading2.default,
	          { weight: 'semibold' },
	          'Bill Monthly'
	        ),
	        _react2.default.createElement(_toggle2.default, {
	          checked: yearlyPriceShown,
	          name: 'toggle',
	          onChange: onSwitch
	        }),
	        _react2.default.createElement(
	          _heading2.default,
	          { weight: 'semibold' },
	          'Bill Yearly'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _BillingSwitch2.default.swirl },
	      _react2.default.createElement(
	        'div',
	        { className: badgeClasses },
	        'Save up to ',
	        discountValue,
	        '% with yearly'
	      ),
	      _react2.default.createElement(_Swirl2.default, { color: 'green' })
	    )
	  );
	}
	
	BillingSwitch.propTypes = {
	  discountValue: _propTypes2.default.number.isRequired,
	  onSwitch: _propTypes2.default.func.isRequired,
	  yearlyPriceShown: _propTypes2.default.bool.isRequired
	};
	
	BillingSwitch.defaultProps = {
	  yearlyPriceShown: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"discount":"_2BbbAOvyAB-xIbHOH_MlZP c-slate fontSize-s fontWeight-3 fontWeight-4 lineHeight-s","originalPrice":"_gTd3H1j4j8R8k1GO1UN1 c-silver fontWeight-4 opacity-60 textDecoration-lineThrough","perYear":"_1l-P15uuIZLNf7fG7nkGEz fontWeight-3"};

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = DiscountPrice;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DiscountPrice = __webpack_require__(765);
	
	var _DiscountPrice2 = _interopRequireDefault(_DiscountPrice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiscountPrice(_ref) {
	  var priceBeforeDiscount = _ref.priceBeforeDiscount,
	      yearlyPrice = _ref.yearlyPrice;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _DiscountPrice2.default.discount },
	    _react2.default.createElement(
	      'span',
	      { className: _DiscountPrice2.default.originalPrice },
	      '$',
	      priceBeforeDiscount
	    ),
	    ' $',
	    yearlyPrice,
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: _DiscountPrice2.default.perYear },
	      'per year'
	    )
	  );
	}
	
	DiscountPrice.propTypes = {
	  priceBeforeDiscount: _propTypes2.default.number.isRequired,
	  yearlyPrice: _propTypes2.default.number.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_1jrRU3WDUv5JaNLnAkJuKW","name":"_2JCdx_4ZPQOyjG9Mgii-UV c-white fontSize-xl fontWeight-5 marginBottom-xxs","description":"-RqVj8BG6cKX9HKhLMflv c-white lineHeight-s fontSize-s fontWeight-3","pricing":"esN9sDjQn8LZsvhhzynSa c-white fontSize-xxl fontWeight-5 lineHeight-xl","button":"_5MLcCw96b43s2A-lJxciI bg-white boxShadow-emboss--hover button--m button--rounded button c-slate","features":"_2ru0CIfHuQ2Sq1q0vXTN-2 paddingLeft-xs paddingTop-m"};

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlanBox = __webpack_require__(209);
	
	var _PlanBox2 = _interopRequireDefault(_PlanBox);
	
	var _PlanFeatureList = __webpack_require__(210);
	
	var _PlanFeatureList2 = _interopRequireDefault(_PlanFeatureList);
	
	var _EnterpriseCard = __webpack_require__(766);
	
	var _EnterpriseCard2 = _interopRequireDefault(_EnterpriseCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availableFeatures = [{
	  description: 'Unlimited users',
	  toolTip: 'With Marvel Enterprise, you decide how many users you need.'
	}, {
	  description: 'Unlimited projects',
	  toolTip: ''
	}, {
	  description: 'Unlimited User Tests',
	  toolTip: 'Scale your testing process with no limits on the amount user tests and results'
	}, {
	  description: 'Download prototypes and designs',
	  toolTip: 'Download your prototypes and designs offline and present them without having to worry about connectivity'
	}, {
	  description: 'Dedicated support',
	  toolTip: 'Get prioritised support and super speedy response time'
	}, {
	  description: 'Remove Marvel branding',
	  toolTip: 'Hide the Marvel logo on your prototypes'
	}, {
	  description: 'Invite-only projects',
	  toolTip: 'Hide sensitive projects from the rest of your workspace'
	}, {
	  description: 'Advanced security settings',
	  toolTip: 'Restrict access to projects, links and more'
	}, {
	  description: 'Single Sign-On (SSO)',
	  toolTip: 'We support all SSO providers and work with IT teams to get everything up and running'
	}, {
	  description: 'Invoice/custom billing',
	  toolTip: 'Pay by bank transfer and custom invoicing requirements'
	}];
	
	function EnterpriseCard() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _PlanBox2.default,
	      { space: 'm', kind: 'enterprise' },
	      _react2.default.createElement(
	        'div',
	        { className: 'padding-xxs' },
	        _react2.default.createElement(
	          'div',
	          { className: _EnterpriseCard2.default.header },
	          _react2.default.createElement(
	            'div',
	            { className: _EnterpriseCard2.default.name },
	            'Enterprise'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _EnterpriseCard2.default.description },
	            'Built for large orgs'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _EnterpriseCard2.default.pricing },
	          'Let\'s chat'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: _EnterpriseCard2.default.button,
	            'data-bypass': true,
	            href: '/enterprise/request-quote/'
	          },
	          'Request a Quote'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _EnterpriseCard2.default.features },
	      _react2.default.createElement(_PlanFeatureList2.default, { features: availableFeatures })
	    )
	  );
	}
	
	exports.default = EnterpriseCard;
	module.exports = exports['default'];

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Swirl;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Swirl(_ref) {
	  var color = _ref.color;
	
	  var className = 'fill-' + color;
	  return _react2.default.createElement(
	    'svg',
	    { className: className, width: '22', height: '16', viewBox: '0 0 22 16' },
	    _react2.default.createElement('path', {
	      d: 'M2.39,17,1,17l.07-2c11.37.39,17.9-4.17,20-14l2,.42C20.83,11.76,13.9,17,2.39,17Z',
	      transform: 'translate(-1 -1)'
	    })
	  );
	}
	
	Swirl.propTypes = {
	  color: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Tick;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tick() {
	  return _react2.default.createElement(
	    "svg",
	    { viewBox: "0 0 14.84 10.21", width: "14", height: "14" },
	    _react2.default.createElement("path", {
	      id: "check",
	      d: "M7,9.5a2.29,2.29,0,0,1-3.32,0L.35,6.18A1.16,1.16,0,0,1,0,5.34a1.15,1.15,0,0,1,.36-.83,1.13,1.13,0,0,1,.83-.35A1.16,1.16,0,0,1,2,4.51L5.34,7.84,12.82.35a1.17,1.17,0,0,1,1.67,0,1.17,1.17,0,0,1,0,1.67Z"
	    })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"_3BieCtki0du9GdS_fu5dvW borderRadius-l borderStyle-solid borderWidth-1 position-relative","default":"_3PUTbA1dwe8F0tJQKTpyS- bg-white borderColor-smoke boxShadow-raise","blue":"AW-nLizOWaKnc6KcQd0WY bg-blue backgroundSize-cover borderColor-blue","enterprise":"_3S_Nf3x1zXEUQMt43OzTLZ bg-black backgroundSize-cover borderColor-black","isCurrent":"_3AQV9Qf8oUf65ifooummRQ"};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PlanBox = __webpack_require__(767);
	
	var _PlanBox2 = _interopRequireDefault(_PlanBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PlanBox(_ref) {
	  var _cx;
	
	  var children = _ref.children,
	      space = _ref.space,
	      kind = _ref.kind,
	      isCurrent = _ref.isCurrent;
	
	  var className = (0, _classnames2.default)(_PlanBox2.default.card, 'padding-' + space, (_cx = {}, _cx[_PlanBox2.default.default] = kind === 'default', _cx[_PlanBox2.default.blue] = kind === 'blue', _cx[_PlanBox2.default.enterprise] = kind === 'enterprise', _cx[_PlanBox2.default.isCurrent] = isCurrent, _cx));
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    children
	  );
	}
	
	PlanBox.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  isCurrent: _propTypes2.default.bool,
	  kind: _propTypes2.default.oneOf(['default', 'blue', 'enterprise']),
	  space: _propTypes2.default.string
	};
	
	PlanBox.defaultProps = {
	  isCurrent: false,
	  kind: 'default',
	  space: '0'
	};
	
	exports.default = PlanBox;
	module.exports = exports['default'];

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"_3kSTY44LN1Ak815pQqz3jg display-flex flexDirection-column height-100 justifyContent-spaceBetween padding-xxs","header":"_3UPm1jfwO09B-RIPO014Nh","name":"_3y3pRKBM2JSAJoFEgmH8VY c-black fontSize-xl fontWeight-5 marginBottom-xxs","description":"_11sKqcFTfO8oB9EIXjH7Jv c-slate lineHeight-s fontSize-s fontWeight-3","features":"_1D6URu2IlHwuPAr6FHINV4 marginBottom-l paddingLeft-xs paddingTop-m","feature":"pYD5S8rpLKRfcJktpDCuf c-slate fontSize-m lineHeight-s verticalAlign-middle","tick":"H2jYfx7V-x4Z52-QFNTio fill-marvel display-inlineBlock paddingRight-s fontSize-m fontWeight-500","pricing":"_2rXo6WCgwzaYwp7LGnScw2","monthlyPrice":"ECyetsYhmD6dYatpb2RiI c-black fontSize-xl lineHeight-xl","billingText":"_28o-_psgrKLkOubMpqifzj c-slate fontSize-s fontWeight-4 lineHeight-s"};

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PlanCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currencySymbolMap = __webpack_require__(723);
	
	var _currencySymbolMap2 = _interopRequireDefault(_currencySymbolMap);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _DiscountPrice = __webpack_require__(599);
	
	var _DiscountPrice2 = _interopRequireDefault(_DiscountPrice);
	
	var _PlanBox = __webpack_require__(209);
	
	var _PlanBox2 = _interopRequireDefault(_PlanBox);
	
	var _PlanFeatureList = __webpack_require__(210);
	
	var _PlanFeatureList2 = _interopRequireDefault(_PlanFeatureList);
	
	var _PlanCard = __webpack_require__(768);
	
	var _PlanCard2 = _interopRequireDefault(_PlanCard);
	
	var _plans = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/no-unresolved
	function numberWithCommas(x) {
	  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}
	
	function PlanCard(_ref) {
	  var availableFeatures = _ref.availableFeatures,
	      billingCycle = _ref.billingCycle,
	      CTAText = _ref.CTAText,
	      handleCTAClick = _ref.handleCTAClick,
	      isCurrentPlan = _ref.isCurrentPlan,
	      isDowngradeToFree = _ref.isDowngradeToFree,
	      monthlyPrice = _ref.monthlyPrice,
	      priceBeforeDiscount = _ref.priceBeforeDiscount,
	      showDiscountPrice = _ref.showDiscountPrice,
	      subTitle = _ref.subTitle,
	      title = _ref.title,
	      yearlyPrice = _ref.yearlyPrice,
	      yearlyPricePerMonth = _ref.yearlyPricePerMonth,
	      currency = _ref.currency;
	
	  var pricePerMonth = Math.ceil(billingCycle === _plans.BILLING_CYCLE_YEARLY ? yearlyPricePerMonth : monthlyPrice);
	  var currencySymbol = (0, _currencySymbolMap2.default)(currency) || '$';
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _PlanBox2.default,
	      { space: 'm', isCurrent: isCurrentPlan },
	      _react2.default.createElement(
	        'div',
	        { className: _PlanCard2.default.card },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _PlanCard2.default.header },
	            _react2.default.createElement(
	              'div',
	              { className: _PlanCard2.default.name },
	              title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _PlanCard2.default.description },
	              subTitle
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _PlanCard2.default.pricing },
	            _react2.default.createElement(
	              'div',
	              { className: _PlanCard2.default.monthlyPrice },
	              _react2.default.createElement(
	                'span',
	                { className: 'fontWeight-7' },
	                currencySymbol,
	                numberWithCommas(pricePerMonth)
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fontWeight-3' },
	                '/ month'
	              )
	            ),
	            billingCycle === _plans.BILLING_CYCLE_YEARLY && pricePerMonth > 0 && _react2.default.createElement(
	              'div',
	              { className: _PlanCard2.default.billingText },
	              'billed yearly'
	            ),
	            !isCurrentPlan && showDiscountPrice && _react2.default.createElement(_DiscountPrice2.default, {
	              yearlyPrice: numberWithCommas(Math.ceil(yearlyPrice)),
	              priceBeforeDiscount: priceBeforeDiscount
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'medium',
	              kind: 'flat',
	              shape: 'rounded',
	              background: 'blue',
	              hoverColor: 'blue',
	              onClick: handleCTAClick,
	              isSad: isDowngradeToFree,
	              isDisabled: isCurrentPlan
	            },
	            CTAText
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _PlanCard2.default.features },
	      _react2.default.createElement(_PlanFeatureList2.default, { features: availableFeatures })
	    )
	  );
	}
	
	PlanCard.propTypes = {
	  availableFeatures: _propTypes2.default.array.isRequired,
	  billingCycle: _propTypes2.default.string,
	  CTAText: _propTypes2.default.string.isRequired,
	  handleCTAClick: _propTypes2.default.func.isRequired,
	  isCurrentPlan: _propTypes2.default.bool.isRequired,
	  isDowngradeToFree: _propTypes2.default.bool.isRequired,
	  monthlyPrice: _propTypes2.default.number,
	  priceBeforeDiscount: _propTypes2.default.number,
	  showDiscountPrice: _propTypes2.default.bool,
	  subTitle: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  yearlyPrice: _propTypes2.default.number,
	  yearlyPricePerMonth: _propTypes2.default.number.isRequired,
	  currency: _propTypes2.default.number.isRequired
	};
	
	PlanCard.defaultProps = {
	  monthlyPrice: 0
	};
	module.exports = exports['default'];

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"grid":"_18NnKc93TYpciwSqKQMVIf","container":"_8p5ensbCfXB-iR3amZbA7 paddingLeft-m position-relative","isLast":"tC0SZfMfFk4vIYW2HkDQ_ marginBottom-xxs","icon":"roaSrGTk0onEcETS8XKxo fill-blue verticalAlign-middle position-absolute pinTL","feature":"_336V1Q0L1NXpAH3U09TG4x c-slate fontSize-s lineHeight-s marginRight-xxs paddingLeft-xxs","featureText":"_2PhCTkdqmP6qpsOQZGHRld display-block fontSize-s","bold":"-NymBNW8VHe0c4hFA9xOe fontWeight-5","light":"_3zXgP9aItk-3KmNPxUkUVR fontWeight-3","toolTip":"_1ffCXV757iJrsCdTxjAtoC display-none marginLeft-xxs verticalAlign-middle breakPointM-display-inlineBlock","toolTipWrap":"_3229wniCIO-Knqi4x1uJ7M display-flex alignItems-center"};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _popover = __webpack_require__(66);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _index = __webpack_require__(602);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _PlanFeatureList = __webpack_require__(769);
	
	var _PlanFeatureList2 = _interopRequireDefault(_PlanFeatureList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PlanFeatureList(_ref) {
	  var features = _ref.features;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _PlanFeatureList2.default.grid },
	    features.map(function (_ref2, index) {
	      var _cx, _cx2, _extends2;
	
	      var description = _ref2.description,
	          toolTip = _ref2.toolTip;
	
	      var firstFeature = index === 0;
	      var containerClasses = (0, _classnames2.default)((_cx = {}, _cx[_PlanFeatureList2.default.isLast] = index !== features.length - 1, _cx));
	      var featureClasses = (0, _classnames2.default)((_cx2 = {}, _cx2[_PlanFeatureList2.default.bold] = firstFeature, _cx2[_PlanFeatureList2.default.light] = !firstFeature, _cx2[_PlanFeatureList2.default.featureText] = true, _cx2));
	
	      var triggerClasses = (0, _classnames2.default)(_extends({}, featureClasses, (_extends2 = {}, _extends2[_PlanFeatureList2.default.featureText] = true, _extends2)));
	
	      return _react2.default.createElement(
	        'div',
	        { key: description, className: containerClasses },
	        _react2.default.createElement(
	          'div',
	          { className: _PlanFeatureList2.default.container },
	          _react2.default.createElement(
	            'div',
	            { className: _PlanFeatureList2.default.icon },
	            _react2.default.createElement(_index2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _PlanFeatureList2.default.feature },
	            toolTip ? _react2.default.createElement(
	              _popover2.default,
	              { showOnHover: true, type: 'dark', width: 280 },
	              _react2.default.createElement(
	                _popover2.default.Trigger,
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: triggerClasses },
	                  description
	                )
	              ),
	              _react2.default.createElement(
	                _popover2.default.Content,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'paddingTopBottom-xs paddingLeftRight-s' },
	                  _react2.default.createElement(
	                    _paragraph2.default,
	                    { size: 's', color: 'white' },
	                    toolTip
	                  )
	                )
	              )
	            ) : _react2.default.createElement(
	              'span',
	              { className: featureClasses },
	              description
	            )
	          )
	        )
	      );
	    })
	  );
	}
	
	PlanFeatureList.propTypes = {
	  features: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    description: _propTypes2.default.string.isRequired,
	    toolTip: _propTypes2.default.string
	  }))
	};
	
	exports.default = PlanFeatureList;
	module.exports = exports['default'];

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var BILLING_CYCLE_MONTHLY = exports.BILLING_CYCLE_MONTHLY = 'monthly';
	var BILLING_CYCLE_YEARLY = exports.BILLING_CYCLE_YEARLY = 'yearly';

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _billingcycle = __webpack_require__(604);
	
	Object.keys(_billingcycle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _billingcycle[key];
	    }
	  });
	});
	
	var _labels = __webpack_require__(605);
	
	Object.keys(_labels).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _labels[key];
	    }
	  });
	});
	
	var _plans = __webpack_require__(606);
	
	Object.keys(_plans).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _plans[key];
	    }
	  });
	});

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var PLAN_LABEL_FREE = exports.PLAN_LABEL_FREE = 'Free';
	var PLAN_LABEL_PRO = exports.PLAN_LABEL_PRO = 'Pro';
	var PLAN_LABEL_COMPANY = exports.PLAN_LABEL_COMPANY = 'Company';
	var PLAN_LABEL_TEAM = exports.PLAN_LABEL_TEAM = 'Team';
	var PLAN_LABEL_ENTERPRISE = exports.PLAN_LABEL_ENTERPRISE = 'Enterprise';

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var FREE_1_PROJECT_PLAN_SLUG = exports.FREE_1_PROJECT_PLAN_SLUG = 'free-6-team-members';
	var FREE_2_PROJECTS_PLAN_SLUG = exports.FREE_2_PROJECTS_PLAN_SLUG = 'free-2-projects';
	var PRO_PLAN_SLUG = exports.PRO_PLAN_SLUG = 'pro';
	var COMPANY_3_PERSON_PLAN_SLUG = exports.COMPANY_3_PERSON_PLAN_SLUG = 'company-3-person';
	var COMPANY_6_PERSON_PLAN_SLUG = exports.COMPANY_6_PERSON_PLAN_SLUG = 'company-6-person';
	
	var MARVEL_PLANS = exports.MARVEL_PLANS = [FREE_1_PROJECT_PLAN_SLUG, PRO_PLAN_SLUG, COMPANY_3_PERSON_PLAN_SLUG];

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var faqItems = [{
	  id: 0,
	  question: 'What happens if I add more team members to my plan?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you\'ve selected (monthly or yearly).'
	  )
	}, {
	  id: 1,
	  question: 'How are Team Members and Contributors different?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Team Members have access to all projects within your Marvel account (great for employees). There is a per user charge for Team Members. Contributors can only see projects they have been specifically invited to (Great for freelancers). Contributors are included with your plan.'
	  )
	}, {
	  id: 2,
	  question: 'Can I cancel or switch at any time?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Yes! You can manage your plan 24/7 in your account section. Any downgrades are immediate and we do not offer refunds for unused time on your monthly or yearly plan.'
	  )
	}, {
	  id: 3,
	  question: 'What payment methods does Marvel accept?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'We accept Visa, Mastercard and American Express. Our Enterprise plan allows you to pay by invoice or bank transfer.'
	  )
	}, {
	  id: 4,
	  question: 'Do you have discounts for students and non-profits?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Yes! Up to 70%! In both cases, we require some additional verification information. Read more',
	    ' ',
	    _react2.default.createElement(
	      _link2.default,
	      {
	        url: 'https://help.marvelapp.com/hc/en-us/articles/360003458197',
	        target: '_blank',
	        type: 'blue'
	      },
	      'here'
	    ),
	    '.'
	  )
	}, {
	  id: 5,
	  question: 'How do I purchase more than 6 team members?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Our Enterprise plan has no limit on team members. Speak to the',
	    ' ',
	    _react2.default.createElement(
	      _link2.default,
	      { url: '/enterprise/request-demo', type: 'blue' },
	      'team'
	    ),
	    ' ',
	    'for a demo and quote based on your needs.'
	  )
	}, {
	  id: 6,
	  question: 'Does Marvel have any time-limits or trials?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Our free plan has no time-limits so you can use Marvel for as long as you need before deciding to upgrade.'
	  )
	}, {
	  id: 7,
	  question: 'How secure is Marvel?',
	  answer: _react2.default.createElement(
	    'span',
	    null,
	    'Drop us a line',
	    ' ',
	    _react2.default.createElement(
	      _link2.default,
	      {
	        url: 'https://help.marvelapp.com/hc/en-us/requests/new',
	        target: '_blank',
	        type: 'blue'
	      },
	      'here'
	    ),
	    '.'
	  )
	}];
	
	exports.default = faqItems;
	module.exports = exports['default'];

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _deanfil2x = __webpack_require__(932);
	
	var _deanfil2x2 = _interopRequireDefault(_deanfil2x);
	
	var _reyelle2x = __webpack_require__(933);
	
	var _reyelle2x2 = _interopRequireDefault(_reyelle2x);
	
	var _rua2x = __webpack_require__(934);
	
	var _rua2x2 = _interopRequireDefault(_rua2x);
	
	var _yav2x = __webpack_require__(935);
	
	var _yav2x2 = _interopRequireDefault(_yav2x);
	
	var _zorast2x = __webpack_require__(936);
	
	var _zorast2x2 = _interopRequireDefault(_zorast2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  deanFil: {
	    alt: 'Two men looking at a print',
	    src: _deanfil2x2.default,
	    width: '100%'
	  },
	  reyElle: {
	    alt: 'Two women looking at a laptop',
	    src: _reyelle2x2.default,
	    width: '100%'
	  },
	  rua: {
	    alt: 'Marvel\'s Office Dog',
	    src: _rua2x2.default,
	    width: '100%'
	  },
	  yav: {
	    alt: 'Man sitting in a library',
	    src: _yav2x2.default,
	    width: '100%'
	  },
	  zorast: {
	    alt: 'Man calling with customers',
	    src: _zorast2x2.default,
	    width: '100%'
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deanfil@2x-768f8865a436d8b3aadd3bb8d4c440bc.jpg";

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reyelle@2x-bd8ad8a5507d73a35392f7cdda38f1de.jpg";

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rua@2x-dda540e5869cc8e488b11f5be4cbe9a8.jpg";

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yav@2x-4c62ad00b5bfdc0713a2d4539f9751fa.jpg";

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/zorast@2x-8973bcb9a8826aeeffc04e5d6b75965e.jpg";

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CtaFooter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(152);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CtaFooter() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bg-marvel c-white' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        null,
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xl', position: 'topBottom', type: 'padding' },
	          _react2.default.createElement(
	            _grid2.default,
	            { columns: 2, size: 'xl', alignItems: 'center' },
	            _react2.default.createElement(
	              _grid.GridItem,
	              { columnSpan: 2, columnSpanM: 1 },
	              _react2.default.createElement(
	                _align2.default,
	                { type: 'center', typeM: 'left' },
	                _react2.default.createElement(
	                  _maxWidth2.default,
	                  { value: 400 },
	                  _react2.default.createElement(
	                    _heading2.default,
	                    { color: 'white', size: 'xxxl', weight: 'semibold' },
	                    'Thousands of teams use Marvel to make design their competitive edge.'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _grid.GridItem,
	              { columnSpan: 2, columnSpanM: 1 },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.customerLogos, {
	                hasShadow: false,
	                useImageTag: false
	              }))
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Faq;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(152);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _FaqItem = __webpack_require__(589);
	
	var _FaqItem2 = _interopRequireDefault(_FaqItem);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _faq = __webpack_require__(624);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _faqModule = __webpack_require__(755);
	
	var _faqModule2 = _interopRequireDefault(_faqModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Faq() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        'div',
	        { className: _faqModule2.default.faq },
	        _react2.default.createElement(
	          'div',
	          { className: _faqModule2.default.text },
	          _react2.default.createElement(
	            'div',
	            { className: _faqModule2.default.textHolder },
	            _react2.default.createElement(
	              'h2',
	              { className: _faqModule2.default.heading },
	              'Frequently asked questions'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _faqModule2.default.image },
	              _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.faq, { width: '100px', hasShadow: false }))
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _faqModule2.default.grid },
	          _faq2.default.map(function (item) {
	            return _react2.default.createElement(
	              _FaqItem2.default,
	              { key: item.id, question: item.question },
	              item.answer
	            );
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Features;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _assets = __webpack_require__(152);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Feature = __webpack_require__(45);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _OffsetBackground = __webpack_require__(77);
	
	var _OffsetBackground2 = _interopRequireDefault(_OffsetBackground);
	
	var _featuresModule = __webpack_require__(756);
	
	var _featuresModule2 = _interopRequireDefault(_featuresModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var features = [{
	  id: 0,
	  image: _assets2.default.students,
	  title: 'Marvel for Education',
	  copy: 'Students and teachers receive 70% off yearly plans. ',
	  url: 'https://help.marvelapp.com/hc/en-us/articles/360003458197-Student-teacher-and-education-discounts'
	}, {
	  id: 1,
	  image: _assets2.default.nonprofit,
	  title: 'Marvel for Non-Profits',
	  copy: 'Registered non-profits receive 50% off yearly plans.',
	  url: 'https://help.marvelapp.com/hc/en-us/articles/360003458277-Charity-and-Non-Profit-discounts'
	}];
	
	function Features() {
	  return _react2.default.createElement(
	    _OffsetBackground2.default,
	    { height: 20 },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', position: 'bottom', type: 'padding' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _featuresModule2.default.container },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'xl', position: 'bottom', type: 'padding' },
	            _react2.default.createElement(
	              _grid2.default,
	              { columns: 2, size: 'xl' },
	              features.map(function (item) {
	                return _react2.default.createElement(
	                  _grid.GridItem,
	                  { key: item.id, columnSpan: 2, columnSpanM: 1 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _featuresModule2.default.item },
	                    _react2.default.createElement(_Image2.default, _extends({}, item.image, { hasShadow: false })),
	                    _react2.default.createElement(
	                      _spacing2.default,
	                      { sizeМ: 'l', position: 'left', type: 'padding' },
	                      _react2.default.createElement(_Feature2.default, {
	                        copy: item.copy,
	                        fontWeight: 'semibold',
	                        title: item.title
	                      }),
	                      _react2.default.createElement(
	                        _align2.default,
	                        { type: 'center', typeM: 'left' },
	                        _react2.default.createElement(
	                          _spacing2.default,
	                          {
	                            size: 'xxs',
	                            position: 'topBottom',
	                            type: 'margin'
	                          },
	                          _react2.default.createElement(
	                            _paragraph2.default,
	                            { size: 'm' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'fontWeight-5' },
	                              _react2.default.createElement(
	                                _link2.default,
	                                {
	                                  type: 'blue',
	                                  url: item.url,
	                                  target: '_blank'
	                                },
	                                'Find out more'
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _buttonCaptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(38);
	
	var _sortBy = __webpack_require__(824);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _camelize = __webpack_require__(699);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _selectors = __webpack_require__(69);
	
	var _urls = __webpack_require__(229);
	
	var _api = __webpack_require__(54);
	
	var _fetch = __webpack_require__(63);
	
	var _BillingSwitch = __webpack_require__(598);
	
	var _BillingSwitch2 = _interopRequireDefault(_BillingSwitch);
	
	var _EnterpriseCard = __webpack_require__(600);
	
	var _EnterpriseCard2 = _interopRequireDefault(_EnterpriseCard);
	
	var _PlanCard = __webpack_require__(603);
	
	var _PlanCard2 = _interopRequireDefault(_PlanCard);
	
	var _plans = __webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var buttonCaptions = (_buttonCaptions = {}, _buttonCaptions[_plans.PLAN_LABEL_FREE] = 'Start with Free', _buttonCaptions[_plans.PLAN_LABEL_PRO] = 'Choose plan', _buttonCaptions[_plans.PLAN_LABEL_COMPANY] = 'Start 7 day free trial', _buttonCaptions[_plans.PLAN_LABEL_TEAM] = 'Start 7 day free trial', _buttonCaptions);
	
	var Pricing = function (_Component) {
	  _inherits(Pricing, _Component);
	
	  function Pricing() {
	    _classCallCheck(this, Pricing);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      toggleYearlyPrice: true,
	      plans: []
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Pricing.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // Fetch plans data from the Marvel backend
	    (0, _fetch.fetchApi)('GET', getPlanUrls()).then(function (plans) {
	      var formattedPlans = (0, _camelize2.default)(plans);
	      _this2.setState({ plans: formattedPlans });
	    });
	  };
	
	  Pricing.prototype.onChange = function onChange() {
	    this.setState({ toggleYearlyPrice: !this.state.toggleYearlyPrice });
	  };
	
	  Pricing.prototype.getSlugUrl = function getSlugUrl(slug, quantity, label) {
	    if (label === _plans.PLAN_LABEL_FREE) return '/signup';
	    var billingCycle = this.state.toggleYearlyPrice ? 'yearly' : 'monthly';
	    var nextUrl = '/upgrade/plan/' + slug + '/billing-cycle/' + billingCycle + '/quantity/' + (quantity || 1) + '/';
	    if (this.props.isLoggedIn) {
	      return '' + nextUrl;
	    }
	    return '/signup?next=' + nextUrl;
	  };
	
	  Pricing.prototype.render = function render() {
	    var _this3 = this;
	
	    var planLength = Object.keys(_plans.MARVEL_PLANS).length + 1;
	    var _state = this.state,
	        toggleYearlyPrice = _state.toggleYearlyPrice,
	        plans = _state.plans;
	
	    var maxWidth = 1320;
	    var breakPointClassName = 'breakPointL-width-20';
	    if (planLength < 5) {
	      breakPointClassName = 'breakPointL-width-25';
	      maxWidth = 920;
	    }
	
	    if (!plans.length) {
	      return null;
	    }
	    var hasTrackedCurrency = false;
	    var sortedPlans = (0, _sortBy2.default)(plans, [function (plan) {
	      var teamMembersCount = plan.teamMembers || 1;
	      if (!hasTrackedCurrency) {
	        if (window && window.heap) {
	          window.heap.track('Marketing Site Paywall Viewed', {
	            currency: plan.currency
	          });
	          hasTrackedCurrency = true;
	        }
	      }
	      return plan.priceMonthly * teamMembersCount;
	    }]);
	
	    return _react2.default.createElement(
	      _pageWrap2.default,
	      { maxWidth: maxWidth },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(_BillingSwitch2.default, {
	          yearlyPriceShown: toggleYearlyPrice,
	          onSwitch: this.onChange,
	          discountValue: 25
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'display-flex grid--m cf flexWrap-wrap' },
	        sortedPlans.map(function (plan) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: plan.slug,
	              className: 'width-100 breakPointS-width-50 breakPointM-width-33 ' + breakPointClassName
	            },
	            _react2.default.createElement(_PlanCard2.default, {
	              availableFeatures: plan.availableFeatures,
	              billingCycle: toggleYearlyPrice ? 'yearly' : 'monthly',
	              CTAText: buttonCaptions[plan.label],
	              currency: plan.currency,
	              handleCTAClick: function handleCTAClick() {
	                window.location.href = '' + _urls.HOST + _this3.getSlugUrl(plan.slug, plan.teamMembers, plan.label);
	              },
	              isCurrentPlan: false,
	              isDowngradeToFree: false,
	              monthlyPrice: divideBy100MultiplyByTeamMembers(plan.priceMonthly, plan.teamMembers),
	              priceBeforeDiscount: divideBy100MultiplyByTeamMembers(plan.priceMonthly * 12, plan.teamMembers),
	              subTitle: plan.subTitle,
	              title: plan.title,
	              yearlyPrice: divideBy100MultiplyByTeamMembers(plan.priceYearly, plan.teamMembers),
	              yearlyPricePerMonth: divideBy100MultiplyByTeamMembers(plan.priceYearly / 12, plan.teamMembers)
	            })
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'width-100 breakPointS-width-50 breakPointM-width-33 ' + breakPointClassName
	          },
	          _react2.default.createElement(_EnterpriseCard2.default, null)
	        )
	      )
	    );
	  };
	
	  return Pricing;
	}(_react.Component);
	
	Pricing.propTypes = {
	  isLoggedIn: _propTypes2.default.bool
	};
	Pricing.defaultProps = {
	  isLoggedIn: false
	};
	
	
	function getPlanUrls() {
	  var urlStrings = '';
	  _plans.MARVEL_PLANS.forEach(function (plan) {
	    urlStrings = '' + urlStrings + plan + ',';
	  });
	  return '' + _api.API_PLANS + urlStrings + '/';
	}
	
	function divideBy100MultiplyByTeamMembers(value, teamMembers) {
	  return value / 100 * (teamMembers || 1);
	}
	
	function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isUserLoggedIn)(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Pricing);
	module.exports = exports['default'];

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Support;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _support = __webpack_require__(625);
	
	var _support2 = _interopRequireDefault(_support);
	
	var _supportModule = __webpack_require__(757);
	
	var _supportModule2 = _interopRequireDefault(_supportModule);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Support() {
	  return _react2.default.createElement(
	    'div',
	    { className: _supportModule2.default.support },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        'div',
	        { className: _supportModule2.default.copy },
	        _react2.default.createElement(
	          'h2',
	          { className: _supportModule2.default.heading },
	          'Support when you need it'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _supportModule2.default.subtitle },
	          'If you have questions around pricing, features or anything else, our support team is just a few clicks away.'
	        ),
	        _react2.default.createElement(
	          _link2.default,
	          {
	            url: 'https://help.marvelapp.com/hc/en-us/requests/new',
	            target: '_blank'
	          },
	          _react2.default.createElement(
	            _button2.default,
	            { size: 'medium', shape: 'rounded', hover: 'blue' },
	            'Chat to us'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _supportModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _supportModule2.default.imagesHolder },
	        _react2.default.createElement(
	          'div',
	          { className: _supportModule2.default.images },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, _extends({}, _support2.default.zorast, { hasShadow: false }))
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, _extends({}, _support2.default.yav, { hasShadow: false }))
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, _extends({}, _support2.default.reyElle, { hasShadow: false }))
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, _extends({}, _support2.default.rua, { hasShadow: false }))
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, _extends({}, _support2.default.deanFil, { hasShadow: false }))
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PricingPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _HeroSkinny = __webpack_require__(148);
	
	var _HeroSkinny2 = _interopRequireDefault(_HeroSkinny);
	
	var _Pricing = __webpack_require__(684);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _Features = __webpack_require__(683);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _CtaFooter = __webpack_require__(681);
	
	var _CtaFooter2 = _interopRequireDefault(_CtaFooter);
	
	var _Faq = __webpack_require__(682);
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _Support = __webpack_require__(685);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _heapTrackEvent = __webpack_require__(1325);
	
	var _heapTrackEvent2 = _interopRequireDefault(_heapTrackEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PricingPage() {
	  (0, _heapTrackEvent2.default)('Viewed old paywall');
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Pricing and plans | Marvel',
	      meta: [{
	        name: 'description',
	        content: 'Pricing for individuals, teams and Enterprise'
	      }, {
	        name: 'keywords',
	        content: 'pricing, price, plans, enterprise, free'
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(_HeroSkinny2.default, {
	      title: 'Supercharge your design productivity',
	      tag: 'h1',
	      copy: 'Marvel is perfect for individuals and teams of all sizes. Start for free.'
	    }),
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', size: 'xl', position: 'bottom' },
	      _react2.default.createElement(_Pricing2.default, null)
	    ),
	    _react2.default.createElement(_Features2.default, null),
	    _react2.default.createElement(_CtaFooter2.default, null),
	    _react2.default.createElement(_Faq2.default, null),
	    _react2.default.createElement(_Support2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"faq":"src-pages-pricing-style----faq-module---faq---YqT-J breakPointS-marginTop-m breakPointM-marginTop-l marginTop-xl flexDirection-column breakPointM-flexDirection-row display-flex","text":"src-pages-pricing-style----faq-module---text---2_Adn width-100","textHolder":"src-pages-pricing-style----faq-module---textHolder---2b1vR height-100 position-relative","grid":"src-pages-pricing-style----faq-module---grid---35ub0 display-grid","image":"src-pages-pricing-style----faq-module---image---1bCmt display-none position-absolute breakPointM-display-block breakPointS-display-none","heading":"src-pages-pricing-style----faq-module---heading---2AdqP textAlign-left fontWeight-5 lineHeight-title breakPointS-fontSize-xxl breakPointM-fontSize-xxxl fontSize-xxxl marginBottom-l"};

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-pages-pricing-style----features-module---container---38hP_ bg-white paddingLeftRight-0 breakPointS-paddingLeftRight-l breakPointM-paddingLeftRight-xl","item":"src-pages-pricing-style----features-module---item---1TCOE display-flex flexDirection-column breakPointM-flexDirection-row alignItems-center"};

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"support":"src-pages-pricing-style----support-module---support---2Ru-2 breakPointS-marginTop-xxs breakPointM-marginTop-xl marginTop-xl breakPointS-marginBottom-xl breakPointM-marginBottom-xxxl marginBottom-xxxl","copy":"src-pages-pricing-style----support-module---copy---2ukel display-flex justifyContent-center flexDirection-column alignItems-center","heading":"src-pages-pricing-style----support-module---heading---3Am4h textAlign-center fontWeight-5 breakPointS-fontSize-xxl breakPointM-fontSize-xxxl fontSize-xxxl lineHeight-title","subtitle":"src-pages-pricing-style----support-module---subtitle---1OE9p textAlign-center lineHeight-copy marginTopBottom-s c-slate breakPointS-fontSize-s breakPointM-fontSize-m fontSize-l","container":"src-pages-pricing-style----support-module---container---20MI2 marginTop-l","imagesHolder":"src-pages-pricing-style----support-module---imagesHolder---2EK35","images":"src-pages-pricing-style----support-module---images---ndPbt"};

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = heapTrackEvent;
	function heapTrackEvent(eventName) {
	  if (typeof window !== 'undefined' && window.heap) {
	    window.heap.track(eventName);
	  }
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-index-js-2c7ba50bc28addca87bb.js